import { useQuery } from '@tanstack/react-query';
import { checkIfAdmin, getAgent, getUser } from '../axios/apiClient';

// Ключи запросов для кэширования
export const queryKeys = {
    user: 'user',
    agent: 'agent',
    isAdmin: 'isAdmin',
};

// Хуки запросов
export const useUser = () => {
    return useQuery({
        queryKey: [queryKeys.user],
        queryFn: getUser,
        staleTime: 100,
        gcTime: 100
    });
};

export const useIsAdmin = () => {
    return useQuery({
        queryKey: [queryKeys.isAdmin],
        queryFn: checkIfAdmin,
        staleTime: 100,
        gcTime: 100
    });
};

export const useAgent = () => {
    return useQuery({
        queryKey: [queryKeys.agent],
        queryFn: getAgent,
        staleTime: 100,
        gcTime: 100
    });
}; 